var map = {
	"./Img-01.jpg": 698,
	"./Img-02.jpg": 699,
	"./Img-03.jpg": 700,
	"./Img-05.jpg": 701,
	"./Img-07.jpg": 702,
	"./K.png": 703,
	"./b.png": 704,
	"./blog-grid/author_img.png": 328,
	"./blog-grid/blog_list1.jpg": 705,
	"./blog-grid/blog_list2.jpg": 706,
	"./blog-grid/blog_list3.jpg": 707,
	"./blog-grid/blog_list4.jpg": 708,
	"./blog-grid/blog_single.png": 329,
	"./blog-grid/comment1.png": 330,
	"./blog-grid/comment2.png": 331,
	"./blog-grid/post_1.jpg": 709,
	"./blog-grid/post_2.jpg": 710,
	"./blog-grid/post_3.jpg": 711,
	"./blog-grid/post_4.jpg": 712,
	"./blog-grid/post_img_1.png": 332,
	"./blog-grid/post_img_2.png": 333,
	"./blog-grid/post_img_3.png": 334,
	"./br_logo.png": 713,
	"./breadcrumb/banner_bg.png": 714,
	"./breadcrumb/service.png": 715,
	"./breadcrumb/service_details.png": 716,
	"./breadcrumb/service_details_one.png": 717,
	"./cart1.jpg": 718,
	"./cart2.jpg": 719,
	"./erp-home/action_img.png": 112,
	"./erp-home/background.png": 335,
	"./erp-home/banner_shap.png": 336,
	"./erp-home/cloud-computing.png": 337,
	"./erp-home/cloud_01.png": 113,
	"./erp-home/cloud_02.png": 114,
	"./erp-home/cloud_03.png": 115,
	"./erp-home/cloud_04.png": 116,
	"./erp-home/cloud_05.png": 117,
	"./erp-home/cloud_06.png": 118,
	"./erp-home/crm_img1.jpg": 338,
	"./erp-home/crm_img2.jpg": 339,
	"./erp-home/crm_img3.jpg": 340,
	"./erp-home/erp_dashboard.jpg": 119,
	"./erp-home/erp_icon1.png": 341,
	"./erp-home/erp_icon2.png": 342,
	"./erp-home/erp_icon3.png": 343,
	"./erp-home/erp_icon4.png": 344,
	"./erp-home/erp_icon5.png": 345,
	"./erp-home/erp_icon6.png": 346,
	"./erp-home/growth.png": 347,
	"./erp-home/img/01.png": 120,
	"./erp-home/img/02.png": 121,
	"./erp-home/img/03.png": 122,
	"./erp-home/img/04.png": 123,
	"./erp-home/img/05.png": 124,
	"./erp-home/img/06.png": 125,
	"./erp-home/img/07.png": 126,
	"./erp-home/img/08.png": 127,
	"./erp-home/img/09.png": 128,
	"./erp-home/img/10.png": 129,
	"./erp-home/img/11.png": 130,
	"./erp-home/img/12.png": 131,
	"./erp-home/img/13.png": 132,
	"./erp-home/img/14.png": 133,
	"./erp-home/img/15.png": 134,
	"./erp-home/img/16.png": 135,
	"./erp-home/img/17.png": 136,
	"./erp-home/img/18.png": 137,
	"./erp-home/img/19.png": 138,
	"./erp-home/img/20.png": 139,
	"./erp-home/quote.png": 348,
	"./erp-home/rocket.png": 140,
	"./erp-home/settings1.png": 349,
	"./erp-home/shape.png": 350,
	"./erp-home/testimonial_img.jpg": 351,
	"./erp-home/testimonial_img2.jpg": 352,
	"./error_bg.png": 720,
	"./favicon.png": 721,
	"./home-chat/Messages.jpg": 353,
	"./home-chat/Messages.png": 141,
	"./home-chat/book.png": 142,
	"./home-chat/box.png": 143,
	"./home-chat/chat.png": 144,
	"./home-chat/chat_01.png": 354,
	"./home-chat/chat_02.png": 355,
	"./home-chat/chat_icon.png": 356,
	"./home-chat/cloud.png": 145,
	"./home-chat/dashboard.png": 357,
	"./home-chat/dot.png": 358,
	"./home-chat/get_started_bg.png": 359,
	"./home-chat/john.png": 146,
	"./home-chat/left_leaf.png": 147,
	"./home-chat/live_chat.png": 148,
	"./home-chat/mobile.png": 149,
	"./home-chat/panguin_img_one.png": 150,
	"./home-chat/panguin_img_three.png": 151,
	"./home-chat/panguin_img_two.png": 152,
	"./home-chat/pluse.png": 153,
	"./home-chat/richard.png": 154,
	"./home-chat/right_leaf.png": 155,
	"./home-chat/skyp_1.png": 360,
	"./home-chat/skyp_2.png": 361,
	"./home-chat/support_dashboard.jpg": 362,
	"./home-chat/triangle.png": 156,
	"./home-chat/video_icon.png": 363,
	"./home-event/about.jpg": 157,
	"./home-event/banner_bg.jpg": 158,
	"./home-event/chat.png": 364,
	"./home-event/conference.jpg": 26,
	"./home-event/digital.jpg": 43,
	"./home-event/dot.png": 365,
	"./home-event/image_01.jpg": 366,
	"./home-event/image_02.jpg": 367,
	"./home-event/image_03.jpg": 368,
	"./home-event/image_04.jpg": 369,
	"./home-event/image_05.jpg": 370,
	"./home-event/image_06.jpg": 371,
	"./home-event/instragram1.jpg": 372,
	"./home-event/instragram2.jpg": 373,
	"./home-event/instragram3.jpg": 374,
	"./home-event/instragram4.jpg": 375,
	"./home-event/instragram5.jpg": 376,
	"./home-event/instragram6.jpg": 377,
	"./home-event/leader.png": 378,
	"./home-event/logo_09.jpg": 379,
	"./home-event/logo_10.jpg": 380,
	"./home-event/logo_11.jpg": 381,
	"./home-event/logo_12.jpg": 382,
	"./home-event/marker.png": 159,
	"./home-event/marketing.jpg": 44,
	"./home-event/meetup.png": 383,
	"./home-event/price_shap.png": 384,
	"./home-event/promo.jpg": 160,
	"./home-event/team1.jpg": 385,
	"./home-event/team2.jpg": 386,
	"./home-event/team3.jpg": 387,
	"./home-event/timer.png": 161,
	"./home-security/about_img_1.jpg": 388,
	"./home-security/about_img_2.jpg": 389,
	"./home-security/apple_icon.png": 162,
	"./home-security/banner.png": 163,
	"./home-security/leaf_clients1.png": 164,
	"./home-security/leaf_clients2.png": 165,
	"./home-security/mackbook.png": 166,
	"./home-security/padlock.png": 167,
	"./home-security/real-estate.png": 390,
	"./home-security/rocket.png": 391,
	"./home-security/security_1.png": 392,
	"./home-security/security_2.png": 393,
	"./home-security/security_3.png": 394,
	"./home-security/security_4.png": 395,
	"./home-security/shap.png": 168,
	"./home-security/sheld_bg.png": 169,
	"./home-security/shield.png": 170,
	"./home-security/windows_icon.png": 171,
	"./home-software/analytices1.png": 396,
	"./home-software/analytices2.png": 397,
	"./home-software/analytices3.png": 398,
	"./home-software/analytices4.png": 399,
	"./home-software/analytices5.jpg": 400,
	"./home-software/analytices6.jpg": 401,
	"./home-software/analytices7.jpg": 402,
	"./home-software/analytices8.jpg": 403,
	"./home-software/case.png": 404,
	"./home-software/down_bg.png": 405,
	"./home-software/elements_five.png": 406,
	"./home-software/elements_four.png": 407,
	"./home-software/elements_one.png": 408,
	"./home-software/elements_six.png": 409,
	"./home-software/elements_three.png": 410,
	"./home-software/elements_two.png": 411,
	"./home-software/line_02.png": 412,
	"./home-software/logo_01.png": 172,
	"./home-software/logo_02.png": 173,
	"./home-software/logo_03.png": 174,
	"./home-software/logo_04.png": 175,
	"./home-software/logo_05.png": 176,
	"./home-software/logo_06.png": 177,
	"./home-software/logo_07.png": 178,
	"./home-software/logo_08.png": 179,
	"./home-software/logo_09.png": 413,
	"./home-software/logo_10.png": 414,
	"./home-software/logo_11.png": 415,
	"./home-software/logo_12.png": 416,
	"./home-software/mackbook.png": 417,
	"./home-software/pie.png": 418,
	"./home-software/setup_img1.png": 419,
	"./home-software/setup_img2.png": 420,
	"./home-software/setup_img3.png": 421,
	"./home-software/shap_3.png": 422,
	"./home-software/shap_one.png": 423,
	"./home-software/shap_two.png": 424,
	"./home-tracking/activity_icon.png": 180,
	"./home-tracking/aliexpress.png": 425,
	"./home-tracking/amazon.png": 426,
	"./home-tracking/analyze_icon.png": 181,
	"./home-tracking/apple.png": 427,
	"./home-tracking/computer_tracking_img.jpg": 428,
	"./home-tracking/crismas.png": 429,
	"./home-tracking/cta.png": 182,
	"./home-tracking/cta_pattern_bg.jpg": 430,
	"./home-tracking/google.png": 431,
	"./home-tracking/left-dot.png": 432,
	"./home-tracking/month.png": 433,
	"./home-tracking/right-dot.png": 434,
	"./home-tracking/tesla.png": 435,
	"./home-tracking/time_icon.png": 183,
	"./home-tracking/tracking_banner_img.png": 184,
	"./home-tracking/watch_1.png": 436,
	"./home-tracking/windows.png": 437,
	"./home2/action_bg.png": 722,
	"./home2/file.png": 185,
	"./home2/inbox.png": 186,
	"./home2/report.png": 187,
	"./home2/undraw.png": 188,
	"./home3/action_image.png": 275,
	"./home3/dimond.png": 276,
	"./home3/logo_01.png": 55,
	"./home3/logo_02.png": 93,
	"./home3/logo_03.png": 94,
	"./home3/logo_04.png": 56,
	"./home3/logo_05.png": 57,
	"./home3/p_feature1.png": 277,
	"./home3/prototype_banner_img.png": 278,
	"./home3/prototype_banner_img2.png": 279,
	"./home3/psd.png": 280,
	"./home3/saas.png": 281,
	"./home3/tab.png": 282,
	"./home4/action_shap.png": 283,
	"./home4/author_img.png": 284,
	"./home4/banner_bg.png": 91,
	"./home4/banner_img.png": 92,
	"./home4/divider.png": 95,
	"./home4/dot.png": 96,
	"./home4/icon01.png": 285,
	"./home4/icon02.png": 286,
	"./home4/icon3.png": 287,
	"./home4/icon_04.png": 288,
	"./home4/icon_05.png": 289,
	"./home4/icon_shape1.png": 290,
	"./home4/icon_shape2.png": 291,
	"./home4/icon_shape3.png": 292,
	"./home4/icon_shape4.png": 293,
	"./home4/process_1.png": 294,
	"./home4/process_2.png": 295,
	"./home4/process_3.png": 296,
	"./home4/process_4.png": 297,
	"./home4/process_5.png": 298,
	"./home4/shape.png": 299,
	"./home4/team1.jpg": 59,
	"./home4/team2.jpg": 33,
	"./home4/work1.png": 300,
	"./home4/work2.png": 301,
	"./home4/work3.png": 302,
	"./home5/01.jpg": 189,
	"./home5/02.jpg": 190,
	"./home5/03.jpg": 191,
	"./home5/banner_img.png": 192,
	"./home5/design1.png": 193,
	"./home5/design2.png": 194,
	"./home5/featured_bg_shape.png": 438,
	"./home5/featured_img1.png": 195,
	"./home5/icon1.png": 439,
	"./home5/icon2.png": 440,
	"./home5/icon3.png": 441,
	"./home5/icon_shape.png": 196,
	"./home5/php.jpg": 197,
	"./home5/shap_tecture.png": 442,
	"./home6/dashboard.jpg": 198,
	"./home6/featured_img_one.jpg": 199,
	"./home6/featured_img_two.jpg": 200,
	"./home6/feedback_img_one.png": 443,
	"./home6/feedback_img_three.png": 444,
	"./home6/feedback_img_two.png": 445,
	"./home6/logo_01.png": 446,
	"./home6/logo_02.png": 447,
	"./home6/logo_03.png": 448,
	"./home6/logo_04.png": 449,
	"./home6/logo_05.png": 450,
	"./home6/shape-1.png": 201,
	"./home6/shape2.png": 202,
	"./home6/trust_img.png": 451,
	"./home6/trust_img2.png": 452,
	"./home7/01.png": 453,
	"./home7/02.png": 454,
	"./home7/03.png": 455,
	"./home7/app.png": 456,
	"./home7/banner.png": 723,
	"./home7/google_icon.png": 457,
	"./home7/iPhoneX2.png": 458,
	"./home7/iPhonex.png": 459,
	"./home7/screenshot1.png": 61,
	"./home7/screenshot2.png": 460,
	"./home7/screenshot3.png": 203,
	"./home7/screenshot4.png": 461,
	"./home7/screenshot5.png": 462,
	"./home7/team_01.jpg": 724,
	"./home7/team_02.jpg": 725,
	"./home7/team_03.jpg": 726,
	"./home7/team_04.jpg": 727,
	"./home7/testimonial_author_img.png": 62,
	"./home7/text_one.png": 463,
	"./home7/text_three.png": 464,
	"./home7/text_two.png": 465,
	"./home8/banner_img.png": 327,
	"./home8/dot.png": 728,
	"./home8/fact.png": 729,
	"./home8/service_item_03.png": 730,
	"./home9/featured_img.png": 99,
	"./home9/featured_img_two.png": 101,
	"./home9/flag.png": 304,
	"./home9/footer.png": 305,
	"./home9/icon1.png": 100,
	"./home9/icon2.png": 41,
	"./home9/icon3.png": 102,
	"./home9/icon4.png": 306,
	"./home9/icon5.png": 307,
	"./home9/icon6.png": 308,
	"./home9/icon7.png": 309,
	"./home9/icon8.png": 310,
	"./home9/icon_shape.png": 40,
	"./home9/icon_shape_two.png": 311,
	"./home9/logo1.png": 103,
	"./home9/logo2.png": 104,
	"./home9/logo3.png": 105,
	"./home9/logo4.png": 106,
	"./home9/logo5.png": 107,
	"./home9/logo6.png": 108,
	"./home9/logo7.png": 109,
	"./home9/logo8.png": 110,
	"./home9/mac.png": 97,
	"./home9/map.png": 312,
	"./home9/shape-footer.png": 313,
	"./home9/shape.png": 98,
	"./home9/shape_two.png": 314,
	"./home9/testimonial_img.png": 111,
	"./home9/testimonial_img2.png": 315,
	"./home9/triangle_bottom.png": 316,
	"./home9/triangle_top.png": 317,
	"./hosting/action_img.png": 466,
	"./hosting/business1.png": 467,
	"./hosting/business2.png": 468,
	"./hosting/h_blog1.jpg": 469,
	"./hosting/h_blog2.jpg": 470,
	"./hosting/hosting-image.png": 204,
	"./hosting/hosting_action_bg.png": 205,
	"./hosting/icon1.png": 471,
	"./hosting/icon10.png": 472,
	"./hosting/icon2.png": 473,
	"./hosting/icon3.png": 474,
	"./hosting/icon4.png": 475,
	"./hosting/icon5.png": 476,
	"./hosting/icon6.png": 477,
	"./hosting/icon7.png": 478,
	"./hosting/icon8.png": 479,
	"./hosting/icon9.png": 480,
	"./hosting/line_01.png": 206,
	"./hosting/line_02.png": 207,
	"./hosting/line_03.png": 208,
	"./hosting/line_04.png": 209,
	"./hosting/line_05.png": 210,
	"./hosting/line_06.png": 211,
	"./hosting/line_07.png": 212,
	"./hosting/line_08.png": 213,
	"./hosting/map.png": 481,
	"./hosting/region_map.png": 482,
	"./login_img.png": 731,
	"./login_img2.png": 732,
	"./logo - Copy.png": 733,
	"./logo-3-2x.png": 734,
	"./logo-sticky-2x.png": 735,
	"./logo-sticky.png": 736,
	"./logo-sticky2.png": 737,
	"./logo-sticky3.png": 738,
	"./logo-sticky4.png": 739,
	"./logo.png": 39,
	"./logo.psd": 740,
	"./logo2.png": 38,
	"./logo2x-2.png": 741,
	"./logo2x.png": 742,
	"./logo3.png": 326,
	"./logo4.png": 743,
	"./logo7.png": 744,
	"./logo8.png": 745,
	"./mega-menu-img/Prototyping_Tool.jpg": 746,
	"./mega-menu-img/analytices.jpg": 747,
	"./mega-menu-img/coming_img.jpg": 748,
	"./mega-menu-img/erp.jpg": 749,
	"./mega-menu-img/home-animation.jpg": 750,
	"./mega-menu-img/home-chat.jpg": 751,
	"./mega-menu-img/home-event.jpg": 752,
	"./mega-menu-img/home-security.jpg": 753,
	"./mega-menu-img/home-track.jpg": 754,
	"./mega-menu-img/home1.jpg": 755,
	"./mega-menu-img/home10.jpg": 756,
	"./mega-menu-img/home11.jpg": 757,
	"./mega-menu-img/home12.jpg": 758,
	"./mega-menu-img/home13.jpg": 759,
	"./mega-menu-img/home14.jpg": 760,
	"./mega-menu-img/home15.jpg": 761,
	"./mega-menu-img/home16.jpg": 762,
	"./mega-menu-img/home17.jpg": 763,
	"./mega-menu-img/home2.jpg": 764,
	"./mega-menu-img/home3.jpg": 765,
	"./mega-menu-img/home4.jpg": 766,
	"./mega-menu-img/home5.jpg": 767,
	"./mega-menu-img/home6.jpg": 768,
	"./mega-menu-img/home7.jpg": 769,
	"./mega-menu-img/home8.jpg": 770,
	"./mega-menu-img/home9.jpg": 771,
	"./mega-menu-img/hosting.jpg": 772,
	"./mega-menu-img/icon/app-d.png": 773,
	"./mega-menu-img/icon/blup.png": 774,
	"./mega-menu-img/pos.jpg": 775,
	"./mega-menu-img/saas2-slider.png": 776,
	"./mega-menu-img/support.jpg": 777,
	"./new-home/back_bg.png": 483,
	"./new-home/banner.png": 214,
	"./new-home/briteverify.png": 215,
	"./new-home/campfire.png": 63,
	"./new-home/email.png": 216,
	"./new-home/kissmetrics.png": 64,
	"./new-home/metorik.png": 65,
	"./new-home/nicereply-1.png": 66,
	"./new-home/p-1.png": 217,
	"./new-home/p-2.png": 218,
	"./new-home/p-3.png": 219,
	"./new-home/tab.png": 220,
	"./new-home/tab_2.png": 221,
	"./new-home/tab_3.png": 222,
	"./new-home/ticket-support.png": 223,
	"./new-home/tree-left.png": 224,
	"./new-home/tree-right.png": 225,
	"./new-home/tree.png": 226,
	"./new-home/update.png": 67,
	"./new-home/webhooks.png": 68,
	"./new-home/wedsite.png": 227,
	"./new/01.png": 778,
	"./new/0111.png": 319,
	"./new/02.png": 779,
	"./new/0222.png": 318,
	"./new/03.png": 780,
	"./new/04.png": 781,
	"./new/05.png": 782,
	"./new/06.png": 783,
	"./new/app_screen.png": 784,
	"./new/blog/blog_grid_1.jpg": 484,
	"./new/blog/blog_grid_2.jpg": 485,
	"./new/blog/blog_grid_3.jpg": 486,
	"./new/blog/blog_grid_4.jpg": 487,
	"./new/blog/blog_grid_5.jpg": 488,
	"./new/blog/blog_grid_6.jpg": 489,
	"./new/blog/blog_grid_7.jpg": 490,
	"./new/blog/blog_grid_8.jpg": 491,
	"./new/case/case_01.jpg": 785,
	"./new/case/case_02.jpg": 786,
	"./new/case/case_03.jpg": 787,
	"./new/case/case_04.jpg": 788,
	"./new/case/case_05.jpg": 789,
	"./new/case/case_06.jpg": 790,
	"./new/case/case_07.jpg": 791,
	"./new/case/case_08.jpg": 792,
	"./new/case/case_09.jpg": 793,
	"./new/case/case_10.jpg": 794,
	"./new/case/case_11.jpg": 795,
	"./new/case/case_12.jpg": 796,
	"./new/case/case_details_01.jpg": 797,
	"./new/case/case_details_02.jpg": 798,
	"./new/case/case_details_03.jpg": 799,
	"./new/case/parallax.png": 800,
	"./new/coming_soon_bg.png": 801,
	"./new/company.jpg": 802,
	"./new/cup.png": 321,
	"./new/digital_img.png": 803,
	"./new/error.png": 492,
	"./new/features_01.png": 804,
	"./new/feedback_shap.png": 805,
	"./new/home-split/contact.png": 806,
	"./new/iPhoneX.png": 31,
	"./new/icon.png": 807,
	"./new/icon/icon1.png": 808,
	"./new/icon/icon2.png": 809,
	"./new/icon2.png": 810,
	"./new/icon3.png": 811,
	"./new/intregration_1.png": 322,
	"./new/intregration_2.png": 323,
	"./new/intregration_3.png": 324,
	"./new/intregration_4.png": 325,
	"./new/laptop.png": 493,
	"./new/laptop_two.png": 812,
	"./new/leaf.png": 320,
	"./new/line_01.png": 494,
	"./new/line_02.png": 495,
	"./new/line_03.png": 496,
	"./new/logo_01.png": 813,
	"./new/logo_02.png": 814,
	"./new/logo_03.png": 815,
	"./new/logo_04.png": 816,
	"./new/logo_05.png": 817,
	"./new/member_01.jpg": 818,
	"./new/new_shape.png": 819,
	"./new/phone.png": 497,
	"./new/price_bg.png": 820,
	"./new/shape_bg.png": 821,
	"./new/solution_01.jpg": 822,
	"./new/solution_02.jpg": 823,
	"./new/startup_banner_bg.png": 824,
	"./new/startup_banner_img.png": 498,
	"./new/startup_shap.png": 825,
	"./new/tab_shape_bg.png": 826,
	"./new/testimonial_bg.png": 827,
	"./new/testimonial_bg_shap.png": 828,
	"./new/testimonial_bg_two.png": 829,
	"./new/video_bg.jpg": 830,
	"./new/video_img_01.png": 831,
	"./new/video_img_02.jpg": 832,
	"./new/web_image.jpg": 30,
	"./new_logo.png": 833,
	"./portfolio-details/pr_details1.jpg": 499,
	"./portfolio-details/pr_details2.jpg": 500,
	"./portfolio-details/pr_details3.jpg": 501,
	"./portfolio-details/pr_details4.jpg": 502,
	"./portfolio/2-columns/grid1.jpg": 503,
	"./portfolio/2-columns/grid2.jpg": 504,
	"./portfolio/2-columns/grid3.jpg": 505,
	"./portfolio/2-columns/grid4.jpg": 506,
	"./portfolio/2-columns/grid5.jpg": 507,
	"./portfolio/2-columns/grid6.jpg": 508,
	"./portfolio/2-columns/grid7.jpg": 509,
	"./portfolio/2-columns/grid8.jpg": 510,
	"./portfolio/3-columns/3_col_1.jpg": 511,
	"./portfolio/3-columns/3_col_10.jpg": 512,
	"./portfolio/3-columns/3_col_11.jpg": 513,
	"./portfolio/3-columns/3_col_12.jpg": 514,
	"./portfolio/3-columns/3_col_2.jpg": 515,
	"./portfolio/3-columns/3_col_3.jpg": 516,
	"./portfolio/3-columns/3_col_4.jpg": 517,
	"./portfolio/3-columns/3_col_5.jpg": 518,
	"./portfolio/3-columns/3_col_6.jpg": 519,
	"./portfolio/3-columns/3_col_7.jpg": 520,
	"./portfolio/3-columns/3_col_8.jpg": 521,
	"./portfolio/3-columns/3_col_9.jpg": 522,
	"./portfolio/full-width/full_1.jpg": 523,
	"./portfolio/full-width/full_10.jpg": 524,
	"./portfolio/full-width/full_11.jpg": 525,
	"./portfolio/full-width/full_12.jpg": 526,
	"./portfolio/full-width/full_2.jpg": 527,
	"./portfolio/full-width/full_3.jpg": 528,
	"./portfolio/full-width/full_4.jpg": 529,
	"./portfolio/full-width/full_5.jpg": 530,
	"./portfolio/full-width/full_6.jpg": 531,
	"./portfolio/full-width/full_7.jpg": 532,
	"./portfolio/full-width/full_8.jpg": 533,
	"./portfolio/full-width/full_9.jpg": 534,
	"./pos/High-end-all-in-one-dual-screen.png": 834,
	"./pos/b_dashboard.png": 835,
	"./pos/cash-register.png": 836,
	"./pos/chat.png": 837,
	"./pos/credit-card.png": 838,
	"./pos/delivery-truck.png": 839,
	"./pos/ezgif-1-997e5035cba4.png": 840,
	"./pos/fotter_shap.png": 841,
	"./pos/icon1.png": 842,
	"./pos/icon2.png": 843,
	"./pos/icon3.png": 844,
	"./pos/item1.png": 845,
	"./pos/item2.png": 846,
	"./pos/item3.png": 847,
	"./pos/laptop.png": 848,
	"./pos/leaf-left.png": 535,
	"./pos/leaf-right.png": 536,
	"./pos/mailbox.png": 849,
	"./pos/man.png": 537,
	"./pos/pattern_01.png": 850,
	"./pos/pattern_02.png": 851,
	"./pos/people.png": 538,
	"./pos/pos.png": 852,
	"./pos/pos_about_img.png": 853,
	"./pos/pos_blog_1.png": 854,
	"./pos/pos_blog_2.png": 855,
	"./pos/pos_blog_3.png": 856,
	"./pos/pos_slideshow1.jpg": 857,
	"./pos/pos_slideshow2.jpg": 858,
	"./pos/pos_slideshow3.jpg": 859,
	"./pos/shape.png": 860,
	"./pos/shape_bg.png": 861,
	"./pos/statistics.png": 862,
	"./pos/tab_pattern.png": 863,
	"./pos/wave_two.png": 864,
	"./pos/women.png": 539,
	"./price/one.png": 865,
	"./price/three.png": 866,
	"./price/two.png": 867,
	"./process/ASAN-logo-icon.png": 868,
	"./process/Avast_Antivirus.png": 869,
	"./process/UTorrent_(logo).png": 870,
	"./process/btFMmsoh.png": 871,
	"./process/logo-slack.png": 872,
	"./process/png-logo-design.png": 873,
	"./qoute.png": 874,
	"./saas/map.png": 875,
	"./seo/bike.png": 876,
	"./seo/car.png": 877,
	"./seo/cloud.png": 878,
	"./seo/cloud_bg.png": 879,
	"./seo/features_img.png": 271,
	"./seo/features_img_two.png": 880,
	"./seo/footer_bg.png": 881,
	"./seo/icon1.png": 268,
	"./seo/icon2.png": 269,
	"./seo/icon3.png": 273,
	"./seo/icon4.png": 272,
	"./seo/icon5.png": 270,
	"./seo/image.png": 267,
	"./seo/logo_01.png": 882,
	"./seo/logo_02.png": 883,
	"./seo/logo_03.png": 884,
	"./seo/logo_04.png": 885,
	"./seo/logo_05.png": 886,
	"./seo/logo_06.png": 887,
	"./seo/logo_07.png": 888,
	"./seo/logo_08.png": 889,
	"./seo/logo_09.png": 890,
	"./seo/shap.png": 891,
	"./seo/studies_img_one.jpg": 892,
	"./seo/studies_img_three.jpg": 893,
	"./seo/studies_img_two.jpg": 894,
	"./seo/triangle_one.png": 264,
	"./seo/triangle_three.png": 266,
	"./seo/triangle_two.png": 265,
	"./svg.svg": 895,
	"./teams/team_01.jpg": 540,
	"./teams/team_02.jpg": 541,
	"./teams/team_03.jpg": 542,
	"./teams/team_04.jpg": 543,
	"./teams/team_10.jpg": 544,
	"./teams/team_12.jpg": 545,
	"./teams/team_5.jpg": 546,
	"./teams/team_6.jpg": 547,
	"./teams/team_7.jpg": 548,
	"./teams/team_8.jpg": 549,
	"./teams/team_9.jpg": 550
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 42;